const messageActionsTypes = {
  SEND_MESSAGE_START: 'SEND_MESSAGE_START',
  SEND_MESSAGE_SUCCESS: 'SEND_MESSAGE_SUCCESS',
  SEND_MESSAGE_FAIL: 'SEND_MESSAGE_FAIL',
  SEND_MESSAGE_STATUS_DISCARD: 'SEND_MESSAGE_STATUS_DISCARD',

  GET_CHATS_START: 'GET_CHATS_START',
  GET_CHATS_SUCCESS: 'GET_CHATS_SUCCESS',
  GET_CHATS_FAIL: 'GET_CHATS_FAIL',

  UPLOAD_IMAGES_START: 'UPLOAD_IMAGES_START',
  UPLOAD_IMAGES_SUCCESS: 'UPLOAD_IMAGES_SUCCESS',
  UPLOAD_IMAGES_FAIL: 'UPLOAD_IMAGES_FAIL',

  ADD_CHAT_MESSAGE: 'ADD_CHAT_MESSAGE',

  GET_CHAT_PAGE_START: 'GET_CHAT_PAGE_START',
  GET_CHAT_PAGE_SUCCESS: 'GET_CHAT_PAGE_SUCCESS',
  GET_CHAT_PAGE_FAIL: 'GET_CHAT_PAGE_FAIL',

  ADD_CHAT_PAGE: 'ADD_CHAT_PAGE',

  READ_QUESTIONS_MESSAGE_SUCCESS: 'READ_QUESTIONS_MESSAGE_SUCCESS',
};

export default messageActionsTypes;
